export const AGENCY_ORIGINS = [
  { value: 'whatsapp', label: 'WhatsApp', color: '#25D366' },
  { value: 'site_proprio', label: 'Site próprio', color: '#49317a' },
  { value: 'plug_imoveis', label: 'Plug Imóveis', color: '#e9b76f' },
  { value: 'chaves_na_mao', label: 'Chaves na Mão', color: '#28E4A8' },
  { value: 'df_imoveis', label: 'DF Imóveis', color: '#FF8585' },
  { value: 'imovelweb', label: 'ImovelWeb', color: '#3b82f6' },
  { value: 'casa_mineira', label: 'Casa Mineira', color: '#944f7a' },
  { value: 'casa_jau', label: 'Casa Jau', color: '#b45309' },
  { value: 'abc_imovel', label: 'ABC Imóvel', color: '#4a5568' },
  { value: 'lead_4_sales', label: 'Lead 4 Sales', color: '#0ea5e9' },
  { value: 'imoveis_sc', label: 'Imóveis-SC', color: '#059669' },
  { value: 'sp_imovel', label: 'SP Imóvel', color: '#7c3aed' },
  { value: 'zl_imovel', label: 'ZL Imóvel', color: '#ea580c' },
  { value: 'zn_imovel', label: 'ZN Imóvel', color: '#dc2626' },
  { value: 'zo_imovel', label: 'ZO Imóvel', color: '#c026d3' },
  { value: 'zs_imovel', label: 'ZS Imóvel', color: '#2563eb' },
  { value: 'litoral_sp', label: 'Litoral SP Imóvel', color: '#06b6d4' },
  { value: 'guia_de_imoveis', label: 'Guia de Imóveis', color: '#1FB386' },
  {
    value: 'guia_de_imoveis_abc',
    label: 'Guia de Imóveis ABC',
    color: '#1FB386',
  },
  {
    value: 'guia_de_imoveis_atibaia',
    label: 'Guia de Imóveis Atibaia',
    color: '#1FB386',
  },
  {
    value: 'guia_de_imoveis_braganca',
    label: 'Guia de Imóveis Bragança',
    color: '#1FB386',
  },
  {
    value: 'guia_de_imoveis_campinas',
    label: 'Guia de Imóveis Campinas',
    color: '#1FB386',
  },
  {
    value: 'guia_de_imoveis_guarulhos',
    label: 'Guia de Imóveis Guarulhos',
    color: '#1FB386',
  },
  {
    value: 'guia_de_imoveis_litoral',
    label: 'Guia de Imóveis Litoral',
    color: '#1FB386',
  },
  {
    value: 'guia_de_imoveis_osasco',
    label: 'Guia de Imóveis Osasco',
    color: '#1FB386',
  },
  {
    value: 'guia_de_imoveis_sp',
    label: 'Guia de Imóveis SP',
    color: '#1FB386',
  },
  {
    value: 'guia_de_imoveis_sorocaba',
    label: 'Guia de Imóveis Sorocaba',
    color: '#1FB386',
  },
];

export const DEFAULT_AGENCY_ORIGINS = [
  'whatsapp',
  'site_proprio',
  'plug_imoveis',
  'chaves_na_mao',
];

export const AGENCY_ORIGIN_VALUES = AGENCY_ORIGINS.map(({ value }) => value);

export const normalizeAgencyOrigins = values => {
  const normalized = Array.from(
    new Set(
      (Array.isArray(values) ? values : [])
        .map(value => String(value || '').trim())
        .filter(Boolean)
    )
  ).filter(value => AGENCY_ORIGIN_VALUES.includes(value));

  return normalized.length ? normalized : [...DEFAULT_AGENCY_ORIGINS];
};
